import React from 'react';
import { Button, Form, Input, Label, Modal, ModalBody, ModalHeader } from '../../../components/Bootstrap';
import { UserListQuery_roles as Role, UserListQuery_users as User } from './__generated__/UserListQuery';
import { UserStatus } from './../../../globalTypes';

interface ManagerUserModalProps {
  toggle: () => void;
  onSubmit: (data) => void;
  user?: User;
  roles: Role[];
}

interface ManagerUserModalState {
  role?: string;
  firstName: string;
  lastName: string;
  email: string;
}

export class ManageUserModal extends React.Component<ManagerUserModalProps, ManagerUserModalState> {
  public onChangeFirstName: any;
  public onChangeLastName: any;
  public onChangeEmail: any;
  constructor(props: ManagerUserModalProps) {
    super(props);

    if (props.user) {
      this.state = {
        firstName: props.user.firstName,
        lastName: props.user.lastName,
        email: props.user.email,
        role: props.user.role ? props.user.role.id : undefined,
      };
    } else {
      this.state = {
        firstName: '',
        lastName: '',
        email: '',
      };
    }

    this.onChangeFirstName = this.onChangeField.bind(this, 'firstName');
    this.onChangeLastName = this.onChangeField.bind(this, 'lastName');
    this.onChangeEmail = this.onChangeField.bind(this, 'email');
  }

  onSubmit = (e) => {
    e.preventDefault();

    this.props.onSubmit({
      id: this.props.user ? this.props.user.id : undefined,
      forInvite: this.props.user ? this.props.user.status === UserStatus.invited : undefined,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      role: this.state.role,
    });
  };

  onChangeRole = (e) => {
    const role = e.target.value == 'Select role' ? undefined : e.target.value;
    this.setState({ role });
  };

  onChangeField = (fieldName, e) => {
    this.setState({
      [fieldName]: e.target.value,
    } as any);
  };

  render() {
    const title = this.props.user ? 'Edit Team Member' : 'Add Team Member';

    const canSubmit = !!this.state.firstName && !!this.state.lastName && !!this.state.email && !!this.state.role;

    return (
      <Modal className='user-management-modal' size='sm' isOpen={true} toggle={this.props.toggle}>
        <ModalHeader className='justify-content-center'>{title}</ModalHeader>
        <ModalBody>
          <Form onSubmit={this.onSubmit} className='user-management-modal-form'>
            <div className='mt-1 mb-2'>
              <Label>Role</Label>
              <Input type='select' value={this.state.role} onChange={this.onChangeRole} required={true}>
                <option value={undefined}>Select role</option>
                {this.props.roles.map((role) => (
                  <option key={role.id} value={role.id}>
                    {role.name}
                  </option>
                ))}
              </Input>
            </div>
            <div className='mt-3 mb-3'>
              <Label>First Name</Label>
              <Input
                value={this.state.firstName}
                onChange={this.onChangeFirstName}
                required={true}
                disabled={!!this.props.user}
              />
            </div>
            <div className='mt-3 mb-3'>
              <Label>Last Name</Label>
              <Input
                value={this.state.lastName}
                onChange={this.onChangeLastName}
                required={true}
                disabled={!!this.props.user}
              />
            </div>
            <div className='mt-3 mb-5'>
              <Label>Email</Label>
              <Input
                value={this.state.email}
                onChange={this.onChangeEmail}
                required={true}
                disabled={!!this.props.user}
              />
            </div>
            <div className='text-center'>
              <Button type='button' color='link' className='me-4' onClick={this.props.toggle}>
                Cancel
              </Button>{' '}
              <Button disabled={!canSubmit} type='submit' color='primary' className='btn--rounded-padded'>
                {this.props.user ? 'Save' : 'Send Invite'}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    );
  }
}
